module.exports = __webpack_public_path__ + "static/img/10areaA_05.fcc8b43.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/10areaA_05.png
// module id = 879
// module chunks = 1